import { token } from '@atlaskit/tokens';
import { AtlassianIcon } from '@atlaskit/logo';
import Avatar from '@atlaskit/avatar';
import { useUser } from '#definitions/user';
import { cssMap } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import type { FunctionComponent } from 'react';

const styles = cssMap({
  avatarStyle: {
    alignSelf: 'flex-start',
    marginLeft: token('space.negative.200', '-17px'),
  },
});

const AtlassianUserIcon: FunctionComponent = () => {
  const user = useUser();
  return (
    <Inline alignInline={'center'}>
      <AtlassianIcon size="xlarge" appearance={'brand'} />
      <Avatar
        size="small"
        src={user?.picture}
        // apply styling to put the avatar in the top-right corner
        as={({ children, ...props }) => (
          <div css={styles.avatarStyle} {...props}>
            {children}
          </div>
        )}
      />
    </Inline>
  );
};

export default AtlassianUserIcon;
